import React, { useState } from 'react';

import { logInfo } from 'apps/promo/helpers/clientLogger';

import PromoInputWrapper from '../PromoInputWrapper';

const PromoInputTextPlain = (props) => {
    const [isFocused, setIsFocused] = useState(false);

    const handlerFocus = () => setIsFocused(true);
    const handlerBlur = () => setIsFocused(false);

    const focus = (e) => {
        if (e.currentTarget) {
            const input = e.currentTarget.firstElementChild;
            input?.focus();
        } else if (__isDev__) {
            logInfo('Focus method not support');
        }
    };

    return (
        <>
            <PromoInputWrapper
                labelText={props.labelText}
                isFocused={isFocused}
                setIsFocused={setIsFocused}
                isFilled={!!props.value}
                hasWhiteBg={props.hasWhiteBg}
                setFocus={focus}
                name={props.name}
                comment={props.comment}
                commentWhite={props.commentWhite}
                commentCenter={props.commentCenter}
            >
                <input
                    id={props.name}
                    maxLength={props.maxLength}
                    value={props.value}
                    type={props.type}
                    onChange={props.onChange}
                    onFocus={handlerFocus}
                    onBlur={handlerBlur}
                />
            </PromoInputWrapper>
        </>
    );
};

export default PromoInputTextPlain;
